import { tokenizeCard, type CardInput } from './tokenizeCard';

export { CardTokenizationError, type CardField, type CardInput, type CardToken } from './tokenizeCard';

/** URL da API do Pagar.me (`VITE_PAGARME_API_URL`). Fica só aqui para os testes mockarem este módulo. */
const PAGARME_API_URL = import.meta.env.VITE_PAGARME_API_URL;

/** Tokeniza o cartão no Pagar.me com a chave pública da organização (`usePaymentGatewayPublicKey`). */
export function tokenizeCardWithPagarme(publicKey: string | null | undefined, card: CardInput) {
  return tokenizeCard({ apiUrl: PAGARME_API_URL, publicKey, card });
}
